import { Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { CheckoutPiggyDescriptionComponent } from "./CheckoutPiggyDescriptionComponent";
import { GameFont } from "../../../common/GameFont";
import { CheckoutPiggyResourcePackage } from "../resources/CheckoutPiggyResourcePackage";
import { HBox } from "../../../common/components/ui/HBox";

export class CheckoutPiggyTokenDescriptionComponent extends CheckoutPiggyDescriptionComponent {
    private static readonly EARN_TEXT = 'EARN';
    private static readonly BY_UPGRADING_TEXT = 'BY UPGRADING\nBUILDINGS';

    private readonly earnText: Text;
    private readonly tokenImage: Sprite;
    private readonly byUpgradingText: Text;

    public constructor(commonResources: CommonResourcesPackage, introResources: CheckoutPiggyResourcePackage) {
        super(commonResources);
        const innerBox = new HBox(8);
        this.descriptionContent.addChild(innerBox);
        this.earnText = new Text(CheckoutPiggyTokenDescriptionComponent.EARN_TEXT, new EarnTextStyle());
        this.tokenImage = new Sprite(introResources.assets_views_piggy_intro_token_png);
        this.tokenImage.width = this.tokenImage.height = 120;
        this.tokenImage.position.y = -23;
        this.byUpgradingText = new Text(CheckoutPiggyTokenDescriptionComponent.BY_UPGRADING_TEXT, new ByUpgradingTextStyle());
        innerBox.addChild(this.earnText, this.tokenImage, this.byUpgradingText);
    }
}

class EarnTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 96,
            fill: [
                '00F7FF',
                '3481FF'
            ]
        });
    }
}

class ByUpgradingTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 46,
            fill: 'FFFFFF'
        });
    }
}